export const NAV = {
  logo: "nav-logo",
  link: (k) => `nav-link-${k}`,
  callBtn: "nav-call-button",
  quoteBtn: "nav-quote-button",
  menuToggle: "nav-menu-toggle",
  mobileLink: (k) => `nav-mobile-link-${k}`,
  themeToggle: "theme-toggle",
};

export const HERO = {
  quoteBtn: "hero-cta-quote",
  visitBtn: "hero-cta-visit",
  whatsappBtn: "hero-cta-whatsapp",
  callBtn: "hero-cta-call",
  form: "hero-enquiry-form",
  formName: "hero-form-name",
  formMobile: "hero-form-mobile",
  formService: "hero-form-service",
  formSubmit: "hero-form-submit",
  formSuccess: "hero-form-success",
};

export const SERVICES = {
  card: (k) => `service-card-${k}`,
};

export const PROJECTS = {
  filter: (k) => `project-filter-${k}`,
  card: (i) => `project-card-${i}`,
  lightboxClose: "project-lightbox-close",
};

export const BEFORE_AFTER = {
  slider: "before-after-slider",
  handle: "before-after-handle",
};

export const GALLERY = {
  filter: (k) => `gallery-filter-${k}`,
  item: (i) => `gallery-item-${i}`,
  close: "gallery-lightbox-close",
};

export const PRICING = {
  card: (k) => `pricing-card-${k}`,
  cta: (k) => `pricing-cta-${k}`,
};

export const CALC = {
  tab: (k) => `calc-tab-${k}`,
  area: "calc-area-input",
  quality: (k) => `calc-quality-${k}`,
  result: "calc-result",
  cta: "calc-cta",
};

export const TESTIMONIALS = {
  prev: "testimonial-prev",
  next: "testimonial-next",
  active: "testimonial-active",
};

export const FAQ = { item: (i) => `faq-item-${i}` };

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  mobile: "contact-mobile",
  email: "contact-email",
  city: "contact-city",
  service: "contact-service",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
};

export const CHAT = {
  toggle: "chat-toggle",
  panel: "chat-panel",
  input: "chat-input",
  send: "chat-send",
  close: "chat-close",
  messages: "chat-messages",
};

export const FLOATING = {
  whatsapp: "floating-whatsapp",
  call: "floating-call",
  scrollTop: "floating-scroll-top",
};
